import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { isEqual } from 'lodash'
// import { Link } from 'react-router'

import { formatCurrency } from '../../../utils/currency'
import { OrderAssessmentIcons, ElementIcons } from '../../../shared/elements/icons'

// Elements
import Check from '../../../shared/elements/check'
import Icon from '../../../shared/elements/icon'
import Inline from '../../../shared/elements/inline'

// Styles
import './extentline.scss'

// Utils
import { translation } from '../../../utils/helpers'

class ExtentLine extends Component {
  constructor (props) {
    super(props)
    this.renderEstimationTaskLine = this.renderEstimationTaskLine.bind(this)
    this.renderTaskPriceLine = this.renderTaskPriceLine.bind(this)
    this.renderSubItems = this.renderSubItems.bind(this)
    this.renderForsiItem = this.renderForsiItem.bind(this)
    this.renderForsiSubItems = this.renderForsiSubItems.bind(this)
    this.renderEstimationExtraLine = this.renderEstimationExtraLine.bind(this)
  }

  renderEstimationTaskLine (item) {
    let extraCSS = ''
    if (item.WasRemoved === true) {
      extraCSS = 'removed'
    }

    if (item.WasAdded === true) {
      extraCSS = 'added'
    }

    return (
      <div className='item'>
        <div className={extraCSS}>{item.TaskName} {item.Extent !== null ? item.Extent : ''}</div>
        { /* item.SubItems !== undefined && item.SubItems !== null && this.renderSubItems(item, this.props.showPrice) */ }
      </div>
    )
  }

  renderEstimationExtraLine (item, parent) {
    let extraCSS = ''
    let workcardExtraCss = ''
    let invoiceExtraCss = ''

    if (this.props.invoiceDisabled) invoiceExtraCss = ' fadeOut'
    if (this.props.workcardDisabled) workcardExtraCss = ' fadeOut'

    let checks = (
      <div className='checks'>
        <div className={'hint--top-right' + invoiceExtraCss} aria-label={translation('14998')}>
          <Inline block>
            <Icon icon={OrderAssessmentIcons.Total_Price} />
            <Check simple checked={item.SelectedInvoice || this.props.invoiceDisabled} onChange={this.props.onInvoiceClick.bind(this, item)} disabled={this.props.invoiceDisabled} />
          </Inline>
        </div>
        <div className={'hint--bottom-right' + workcardExtraCss} aria-label={translation('14997')}>
          <Inline block>
            <Icon icon={OrderAssessmentIcons.Workcard} />
            <Check simple checked={item.SelectedWorkCard || this.props.workcardDisabled} onChange={this.props.onWorkCardClick.bind(this, item)} disabled={this.props.workcardDisabled} />
          </Inline>
        </div>
      </div>
    )

    let added = parent.OrderEstimationTaskId !== null

    return (
      <div className='estimationExtra' key={'estimationExtra_' + item.OrderEstimationExtraId}>
        {item.Selectable && checks}
        <div key={'subItem_' + item.OrderEstimationExtraId} className='estimationExtra-child'>
          <div className={'extraContent' + (added ? ' added' : '')}>
            <div className={extraCSS}>{item.Name} </div>
            <div className={extraCSS}>({translation('13345')}: {item.AE} ; {translation('13443')}: {formatCurrency(item.Material)} {this.props.currencyCode})</div>
          </div>
          {item.Gross !== null && (
            <div className='smallRight'>
              <div>{formatCurrency(item.Gross)} {this.props.currencyCode}</div>
            </div>
          )}
        </div>
      </div>
    )
  }

  renderTaskPriceLine (item) {
    let showNet = this.props.showNet === true
    let price = showNet ? item.Net : item.Gross
    price = formatCurrency(price)

    let extraCSS = ''
    if (item.WasRemoved === true) {
      extraCSS = 'removed'
    }

    if (item.WasAdded === true) {
      extraCSS = 'added'
    }

    return (
      <div>
        <div className={extraCSS}>{item.TaskName}</div>
        <div className={'priceRight ' + extraCSS}>{price} {this.props.currencyCode}</div>
      </div>
    )
  }

  renderSubItems (item) {
    let isEstimation = item.EstimationTaskId !== null
    let isTaskPrice = item.TaskPriceId !== null

    let extraCSS = ''
    if (item.WasRemoved === true) {
      extraCSS = 'removed'
    }

    if (item.WasAdded === true) {
      extraCSS = 'added'
    }

    const renderSubItem = (subItem, index) => {
      if (isEstimation) {
        if (this.props.showPrice === true) {
          return (
            <div key={'subItem_' + index}>
              <div className=''>
                <div className={extraCSS}>{subItem.Name} </div>
                <div className={extraCSS}>({translation('13345')}: {subItem.AE} ; {translation('13443')}: {formatCurrency(subItem.Material)} {this.props.currencyCode})</div>
              </div>
              <div className='smallRight'>
                <div>{formatCurrency(subItem.Gross)} {this.props.currencyCode}</div>
              </div>
            </div>
          )
        } else {
          return (
            <div key={'subItem_' + index}>
              <div className={extraCSS}>{subItem.Name} </div>
              <div className={extraCSS}>({translation('13345')}: {subItem.AE} ; {translation('13443')}: {formatCurrency(subItem.Material)} {this.props.currencyCode})</div>
            </div>
          )
        }
      }
      if (isTaskPrice) {
        return (
          <div>&nbsp;</div>
        )
      }
    }
    return (
      <div className='subItem-parent'>{item.SubItems.map(renderSubItem)}</div>
    )
  }

  renderForsiItem (item) {
    let icon = null
    if (item.Selectable === false) {
      icon = <Icon icon={ElementIcons.Indent} size='t' />
    }
    if (item.OrderEstimationTaskId !== null) {
      return (
        <div>
          <span className='forsiItemLeft removed'>{icon}{item.ReportLineAdditionalText}</span>
          <span className='forsiWorkUnitRight removed'>{item.WorkUnits} {translation('13345')}</span>
          <div className='clearFix' />
          <span className='forsiItemLeft added'>{icon}{item.TaskName} {item.Extent ? item.Extent : ''}</span>
          <span className='forsiWorkUnitRight added' />
          <div className='clearFix' />
          { /* item.SubItems !== undefined && item.SubItems !== null && this.renderForsiSubItems(item) */ }
        </div>
      )
    } else {
      let extraCss = ''
      if (this.props.entry && this.props.entry.Type === 4) {
        extraCss = ' afterevalitem'
      }
      return (
        <div>
          <span className={'forsiItemLeft' + extraCss}>{icon}{item.ReportLineAdditionalText} {item.Extent ? item.Extent : ''}</span>
          <span className='forsiWorkUnitRight'>{item.WorkUnits} {translation('13345')}</span>
          <div className='clearFix' />
          {item.SubItems && this.renderForsiSubItems(item)}
        </div>
      )
    }
  }

  renderForsiSubItems (item) {
    let isEstimation = item.EstimationTaskId !== null
    let isTaskPrice = item.TaskPriceId !== null
    const renderSubItems = (subItem, index) => {
      if (isEstimation) {
        return (
          <div className='subItem' key={'subItem_' + index}>
            <div>{subItem.Name}</div>
            <div>({translation('13345')}: {subItem.AE} ; {translation('13443')}: {formatCurrency(subItem.Material)} {this.props.currencyCode})</div>
          </div>
        )
      }
      if (isTaskPrice) {
        return (
          <div>&nbsp;</div>
        )
      }
    }
    return (
      <div>{item.SubItems.map(renderSubItems)}</div>
    )
  }

  render () {
    let item = this.props.item
    let isEstimation = item.EstimationTaskId !== undefined && item.EstimationTaskId !== null
    let isTaskPrice = item.TaskPriceId !== undefined && item.TaskPriceId !== null
    let isReport = item.PaintLineId !== undefined && item.PaintLineId !== null
    // let isEstimationExtra = item.EstimationExtraId !== undefined && item.EstimationExtraId !== null

    let extraCSS = ''
    let icon = null

    let content = <div />

    if (isEstimation) content = this.renderEstimationTaskLine(item)
    if (isTaskPrice) content = this.renderTaskPriceLine(item)
    if (isReport) content = this.renderForsiItem(item)
    // if (isEstimationExtra) content = this.renderEstimationExtraLine(item)

    if (item.Selectable === false) {
      extraCSS = ' fullWidth'
    }

    let workcardExtraCss = ''
    let invoiceExtraCss = ''

    if (this.props.invoiceDisabled) invoiceExtraCss = ' fadeOut'
    if (this.props.workcardDisabled) workcardExtraCss = ' fadeOut'

    return (
      <div className='extentLine'>
        {item.Selectable && item.TaskName !== null && (
        <div className='checks'>
          <div className={'hint--top-right' + invoiceExtraCss} aria-label={translation('14998')}>
            <Inline block>
              <Icon icon={OrderAssessmentIcons.Total_Price} />
              <Check simple checked={item.SelectedInvoice || (isEstimation && this.props.invoiceDisabled)} onChange={this.props.onInvoiceClick.bind(this, item)} disabled={this.props.invoiceDisabled} />
            </Inline>
          </div>
          <div className={'hint--bottom-right' + workcardExtraCss} aria-label={translation('14997')}>
            <Inline block>
              <Icon icon={OrderAssessmentIcons.Workcard} />
              <Check simple checked={item.SelectedWorkCard || (isEstimation && this.props.workcardDisabled)} onChange={this.props.onWorkCardClick.bind(this, item)} disabled={this.props.workcardDisabled} />
            </Inline>
          </div>
        </div>
        )}
        {(item.TaskName !== null || item.ReportLineAdditionalText !== null) && <div className={'content' + extraCSS}>{icon}{content}</div>}
        {item.SubItems !== null && item.SubItems.map(subItem => this.renderEstimationExtraLine(subItem, item))}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {

})(ExtentLine)



// WEBPACK FOOTER //
// ./src/app/pages/EvaluationHistory/ExtentLine/index.js